/** Adhoc booth timing — override via webpack DefinePlugin / .env */

export const ADHOC_IDLE_TIMEOUT_MS = parseInt(
  process.env.ADHOC_IDLE_TIMEOUT_MS || `${30 * 60 * 1000}`,
  10,
);

export const ADHOC_PAYMENT_TIMEOUT_MS = parseInt(
  process.env.ADHOC_PAYMENT_TIMEOUT_MS || `${10 * 60 * 1000}`,
  10,
);

export const ADHOC_DONE_RESET_MS = parseInt(
  process.env.ADHOC_DONE_RESET_SEC || '30',
  10,
) * 1000;

/** After payment cancel/fail, return to landing (Phase 2) */
export const ADHOC_PAYMENT_FAIL_RESET_MS = parseInt(
  process.env.ADHOC_PAYMENT_FAIL_RESET_SEC || '3',
  10,
) * 1000;

/** Poll interval while waiting for Stripe webhook after redirect */
export const ADHOC_PAYMENT_CONFIRM_POLL_MS = 2000;

/** Max polls (~60s) before giving up on payment confirmation */
export const ADHOC_PAYMENT_CONFIRM_MAX_POLLS = 30;

/** Empty string = staff gesture only, no PIN */
export const ADHOC_STAFF_PIN: string = process.env.ADHOC_STAFF_PIN || '';

export function resolveAdhocId(search: string): string {
  const params = new URLSearchParams(search);
  return (
    params.get('adhoc_id')
    || params.get('mall_id')
    || params.get('kiosk_id')
    || 'default'
  );
}
